import { FormModel } from '../../../../../components/Form';
import { addonsType } from '../../../../../utils/constants/data';

/** Optional fields for bulk update — empty values are ignored on save. */
export const BulkEditAddOnsForm = (strings: any, addOnCategories: any): FormModel[] => {
  return [
    {
      label: strings.addOn_text_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'addOnType',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      options: addonsType(strings) as any,
    },
    {
      label: strings.addOn_text_category,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'addOnCategory',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      options: addOnCategories,
    },
    {
      label: strings.addOn_text_price,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'price',
      inputProps: { min: 0 },
      validators: [],
      responsive: { xs: 12, sm: 6 },
      required: false,
    },
    {
      label: strings.addOn_title_maxCount,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'maxCount',
      validators: [],
      responsive: { xs: 12, sm: 6 },
      required: false,
    },
    {
      label: strings.addOnHsnCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      placeholder: '',
      field: 'hsnCode',
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: strings.addOn_text_taxGroup,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.addOn_text_taxGroup,
      field: 'taxGroup',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      isMulti: false,
      isClearable: true,
    },
  ];
};
